import { Language } from '~/types/api/users'

const LANGUAGE_LOCAL_STORAGE_KEY = 'language'

export const setLanguageLocalStorage = (language: Language) => {
  if (typeof window !== 'undefined') {
    window.localStorage.setItem(LANGUAGE_LOCAL_STORAGE_KEY, language)
  }
}

export const getLanguageLocalStorage = (): string | undefined => {
  if (typeof window === 'undefined') {
    return undefined
  }

  const value = window.localStorage.getItem(LANGUAGE_LOCAL_STORAGE_KEY)

  if (value === null) {
    return undefined
  }

  return value
}
